import axios from 'axios'

Plugin.install = function(Vue, { store }) {
  const _axios = axios.create()
  const _baseUrl = /^\/(?<base>\w+)\/(?<path>.*)$/

  Vue.axios = _axios

  _axios.interceptors.request.use(
    function(config) {
      const url = config.url

      const rnd = (x) => (~~(Math.random()*x))
      const digest = [...Array(16)]
        .map(() => rnd(36).toString(36))
        .map((x) => (rnd(2) == 1) ? x.toUpperCase() : x )
        .join('')

      if (_baseUrl.test(url)) {
        const { base, path } = _baseUrl.exec(url).groups
        switch (base) {
        case 'auth':
          config.url = `https://api.driveup.info/auth/${path}`
          config.data.digest = digest
          break
        case 'query':
          if (!('X-DRIVEUP-DIGEST' in config.headers)) {
            // config.headers['X-DRIVEUP-DIGEST'] = store.state.login['digest']
            config.headers['X-DRIVEUP-DIGEST'] = store.getters['login/getDigest']
          }
          if (!('X-DRIVEUP-TOKEN' in config.headers)) {
            // config.headers['X-DRIVEUP-TOKEN'] = store.state.login['jwt']
            config.headers['X-DRIVEUP-TOKEN'] = store.getters['login/jwt']
          }
          if (!('Content-Type' in config.headers)) {
            config.headers['Content-Type'] = 'application/json'
          }
          config.url = `https://api.driveup.info/consultasphp/lists/${path}`
          break
        default:
          throw `endpoint inexistente ${base}`
        }
      }
      return config
    },
    function(error) {
      // TODO: mostrar snacktext
      return Promise.reject(error)
    }
  )

  Object.defineProperties(Vue.prototype, {
    $axios: {
      get() {
        return _axios
      },
    },
  })
}

export default Plugin
